import React, { useState, useEffect, useRef } from 'react';
import { Postdata } from '../API/GlobalApi';

const StudentSearch = ({ nameInputRef, onSelectStudent, setStudentsData, resetTrigger }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [hasSelected, setHasSelected] = useState(false);
  const [showNotFound, setShowNotFound] = useState(false);

  const [isDisabled, setIsDisabled] = useState(false);

  // Reset on external trigger
  useEffect(() => {
    setSearchTerm('');
    setIsDropdownVisible(false);
    setHasSelected(false);
    setShowNotFound(false);
  }, [resetTrigger]);

  // useEffect(() => {
  //   const input = searchTerm.trim();

  //   if (input.length >= 5 && !hasSelected) {
  //     getStudentByMobile(input);
  //   } else {
  //     setIsDropdownVisible(false);
  //     setShowNotFound(false);
  //   }
  // }, [searchTerm, hasSelected]);


  const debounceDelay = 300; // milliseconds

  useEffect(() => {
    if (searchTerm.trim().length >= 5 && !hasSelected) {
      const handler = setTimeout(() => {
        getStudentByMobile(searchTerm.trim());
      }, debounceDelay);

      return () => clearTimeout(handler); // cancel previous timeout
    } else {
      setIsDropdownVisible(false);
      setShowNotFound(false);
    }
  }, [searchTerm, hasSelected]);



  const getStudentByMobile = async (mobile) => {
    try {
      const response = await Postdata('students/get-user-profile/', { mobile });

      // New format: { data: { user_id, full_name, mobile, profile, career_arc_inquiry?, finance_data? } }
      if (response?.data?.user_id) {
        const student = {
          user_id: response.data.user_id,
          mobile: response.data.mobile,
          profile_name: response.data.profile,
          full_name: response.data.full_name,
          career_arc_inquiry: response.data.career_arc_inquiry || null,
          finance_data: response.data.finance_data || null,
        };
        setStudentsData(student);
        handleSelect(student);

        // Old format: { user_id, mobile, profile_name, related_data: {...} }
      } else if (response?.user_id) {
        const student = {
          ...response.related_data,
          mobile: response.mobile,
          user_id: response.user_id,
          profile_name: response.profile_name,
          academic_groups: response.academic_groups,
          finance_data: response.finance_data,
        };
        setStudentsData(student);
        handleSelect(student);

      } else {
        setIsDropdownVisible(true);
        setShowNotFound(true);
      }
    } catch (err) {
      setIsDropdownVisible(true);
      setShowNotFound(true);
    }
  };

  const handleSelect = (student) => {
    if (searchTerm === student.mobile) {
      setSearchTerm(student.mobile);
    } else {
      setSearchTerm(searchTerm);
    }

    setIsDropdownVisible(false);
    setHasSelected(true);
    setShowNotFound(false);
    onSelectStudent && onSelectStudent(student);
  };
  const [lastInputTime, setLastInputTime] = useState(Date.now());




  // === Scanner detection variables ===
  const lastKeyTimeRef = useRef(0);
  const scannerModeRef = useRef(false);
  const KEYPRESS_THRESHOLD = 35; // ms between keys → scanner

  const handleKeyDown = (e) => {
    const now = Date.now();
    const diff = now - lastKeyTimeRef.current;
    lastKeyTimeRef.current = now;

    // VERY fast key presses → scanner
    if (diff < KEYPRESS_THRESHOLD) {
      scannerModeRef.current = true;
    } else {
      // slow → keyboard
      scannerModeRef.current = false;
    }
  };

  const handleChange = (e) => {
    const incoming = e.target.value;

    const isScanner = scannerModeRef.current;

    // console.log("Scanner?", isScanner, incoming);

    if (isScanner) {
      // Allow full scanned QR / Barcode text
      setSearchTerm(incoming);
    } else {
      // Manual typing → allow only digits
      const filtered = incoming.replace(/\D/g, "").slice(0, 10);
      setSearchTerm(filtered);
    }

    setHasSelected(false);
    setShowNotFound(false);
  };


  // ... existing code ...



  //   const handleChange = (e) => {
  //   let incoming = e.target.value.replace(/\D/g, ""); // digits only
  //   let prev = searchTerm;

  //   // Detect scanner input (big jump in length)
  //   const isScannerInput = incoming.length - prev.length > 1;

  //   // Allow scanner full input, but limit manual typing to 10 digits
  //   if (!isScannerInput && incoming.length > 10) {
  //     incoming = incoming.slice(0, 10);
  //   }

  //   setSearchTerm(incoming);
  //   setHasSelected(false);
  //   setShowNotFound(false);
  // };



  // const handleKeyDown = (e) => {
  //   if (e.key === 'Enter') {
  //     e.preventDefault();
  //   }
  // };

  useEffect(() => {
    if (!isDisabled && nameInputRef?.current) {
      nameInputRef.current.focus();
    }
  }, []);

  return (
    <div style={{ margin: '0 auto', paddingTop: '40px' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          padding: '10px',
          background: 'white',
          borderRadius: '10px',
          boxShadow: isDisabled ? '' : '0 0 10px rgba(0,0,0,0.1)',
          background: isDisabled ? "#f5f5f5" : "white",
          marginBottom: '10px',
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#7F56DA"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{ marginRight: '8px' }}
        >
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>

        <input
          type="text"
          placeholder="Search by  Mobile No or QR Scan..."
          value={searchTerm}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          maxLength={30}
          // pattern="\d{10}"
          // style={{
          //   border: 'none',
          //   outline: 'none',
          //   width: '100%',
          //   fontSize: '16px',
          // }}
          disabled={isDisabled}
          style={{
            border: "none",
            outline: "none",
            width: "100%",
            fontSize: "16px",
            background: "transparent",
            color: isDisabled ? "#999" : "black"
          }}
          ref={nameInputRef}
        />


        {/* Toggle Switch */}
        {/* QR Scan Toggle */}
        <div
          onClick={() => setIsDisabled((prev) => !prev)}
          style={{ cursor: "pointer", marginLeft: "10px" }}
          title={isDisabled ? "Enable Search (QR Scan Disabled)" : "Disable Search (QR Scan Enabled)"}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke={isDisabled ? "#bbb" : "#7F56DA"}   // ✅ Light when disabled, dark when enabled
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="3" y="3" width="7" height="7" />
            <rect x="14" y="3" width="7" height="7" />
            <rect x="14" y="14" width="7" height="7" />
            <path d="M3 14h3v3H3zM10 14h1v7h-1zM10 10h1v1h-1z" />
          </svg>
        </div>



      </div>

      {isDropdownVisible && showNotFound && (
        <div
          style={{
            background: 'white',
            borderRadius: '10px',
            boxShadow: '0 0 10px rgba(0,0,0,0.1)',
            maxHeight: '250px',
            overflowY: 'auto',
            padding: '10px',
          }}
        >
          <div style={{ padding: '8px', fontSize: '14px', color: 'red' }}>
            No student found.
          </div>
        </div>
      )}
    </div>
  );
};

export default StudentSearch;
